module.exports = __webpack_public_path__ + "img/international.fabfc03b.png";